import { create } from "zustand";
import { api } from "../utils/axios-instance";
import useAuth from "../stores/authStore";

export const useFileStore = create((set, get) => ({
  files: [],
  filteredData: [],
  selectedFiles: [],
  folders: [],
  anchorEl: null,
  departmentFiles: [],
  isMultiSelect: false,
  openInChat: false,
  allFiles: [],
  refreshRecycleBin: false,
  refreshFolders: false,

  setFiles: (files) => set({ files }),
  setFilteredData: (filteredData) => set({ filteredData }),
  setSelectedFiles: (selectedFiles) => set({ selectedFiles }),
  setFolders: (folders) => set({ folders }),
  setAnchorEl: (anchorEl) => set({ anchorEl }),
  setDepartmentFiles: (departmentFiles) => set({ departmentFiles }),
  setIsMultiSelect: (isMultiSelect) => set({ isMultiSelect }),
  setOpenInChat: (openInChat) => set({ openInChat }),
  setRefreshRecycleBin: (refreshRecycleBin) => set({ refreshRecycleBin }),
  setRefreshFolders: (refreshFolders) => set({ refreshFolders }),

  removeFile: async (fileid) => {
    const { filteredData, setAnchorEl } = get();
    const updatedData = filteredData.filter((file) => file.id !== fileid);
    setAnchorEl(null);
    set({ filteredData: updatedData });
  },

  updateFilesState: async (value = 0, formatFileSize, departments) => {
    // const { formatFileSize } = useAuth();
    // const { departments } = useDepartment();
    let url;
    console.log(value, formatFileSize, departments);

    switch (parseInt(value)) {
      case 0:
        url = `/file/files`;
        break;
      case 1:
        url = `/file/files?type=shared`;
        break;
      case 2:
        url = `/file/files?type=received`;
        break;
      case 3:
        url = `/file/files?type=owned`;
        break;
      case 4:
        url = `/file/files?type=pinned`;
        break;
      default:
        url = `/file/files`;
    }

    const profileData = useAuth.getState().profileData;
    const pinned_files = profileData?.pinned_files || [];

    if (url) {
      try {
        const getFiles = await api.get(url);
        const pinnedSet = new Set(pinned_files);
        set({ files: getFiles.data });

        const mappedFiles = getFiles.data.map((file) => {
          const department = (departments || []).find(
            (dept) => dept.id === file.department_ids?.[0]
          );

          return {
            id: file.id,
            versionId: file.versionId ?? "",
            folderId: file.folder_id ?? "",
            name: file?.name?.substring(0, 80),

            // avatar + owner
            profilePic: file.profilePic ?? file.profile_pic ?? "",
            owner: file.owner_id,
            owner_id: file.owner_id,

            // preview/rendering
            mimetype: file?.metadata?.mimetype,
            download_url: file.download_url ?? file.downloadUrl ?? "",
            downloadUrl: file.download_url ?? file.downloadUrl ?? "",

            // department
            dept: file.department_ids ?? [],

            // IMPORTANT FIX
            department: department?.name ?? "",

            // IMPORTANT FIX
            color: department?.metadata?.bg ?? "",

            size: formatFileSize(file.metadata.size) ?? "",
            lastUpdate: file?.metadata?.lastModified
              ? new Date(file.metadata.lastModified).toLocaleString("en-IN", {
                  day: "numeric",
                  month: "short",
                  year: "numeric",
                  hour: "numeric",
                  minute: "numeric",
                  hour12: true,
                })
              : "",

            // security
            isLocked: file?.security?.is_locked ?? false,
            lockedBy: file?.security?.locked_by ?? null,
            lockedByRole: file?.security?.locked_by_role ?? null,
            hasPassword: file?.security?.has_password ?? false,
            password: file?.security?.password_hash ?? "",
            isPinned: pinnedSet.has(file.id),

            // drive
            drive_link: file?.drive_link,
            drive_file_id: file?.drive_file_id,

            // versioning (if present)
            versions: file?.versions ?? file?.versioning?.versions ?? [],
            currVersion:
              file?.currVersion ?? file?.versioning?.curr_version ?? "",
          };
        });

        console.log(mappedFiles, "zustnad");

        set({ filteredData: mappedFiles });
      } catch (error) {
        console.error(error);
      }
    }
  },

  updateDepartmentFiles: async (deptName, departments) => {
    // const { departments } = useDepartment();
    try {
      const response = await api.get(`/file/files/${deptName}`);
      const filteredFiles = response.data.filter((file) =>
        file.dept.includes(deptName)
      );
      set({ departmentFiles: filteredFiles });
    } catch (error) {
      console.error(error);
    }
  },

  togglePinLocal: (fileId, isPinned) => {
    const updateFile = (file) => {
      if (file.id !== fileId) return file;

      return {
        ...file,
        isPinned,
      };
    };

    const sortPinned = (files) =>
      [...files].sort((a, b) => Number(b.isPinned) - Number(a.isPinned));

    set((state) => ({
      files: sortPinned(state.files.map(updateFile)),
      filteredData: sortPinned(state.filteredData.map(updateFile)),
      departmentFiles: sortPinned(state.departmentFiles.map(updateFile)),
    }));
  },

  toggleLockLocal: (fileId, isLocked) => {
    const updateFile = (file) => {
      if (file.id !== fileId) return file;

      return {
        ...file,
        isLocked,
        security: {
          ...(file.security || {}),
          is_locked: isLocked,
        },
      };
    };

    set((state) => ({
      files: state.files.map(updateFile),
      filteredData: state.filteredData.map(updateFile),
      departmentFiles: state.departmentFiles.map(updateFile),
    }));
  },

  fileRefreshKey: 0,

  triggerFileRefresh: () =>
    set((state) => ({
      fileRefreshKey: state.fileRefreshKey + 1,
    })),
}));
